import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PLATFORM_ENVIRONMENT } from '@platform-frontend/platform';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionEulaUpdateService {
  constructor(private http: HttpClient) {}

  confirmEulaUpdates(licenseTypeIds: string[]): Observable<unknown> {
    return this.http.post<void>(PLATFORM_ENVIRONMENT.apiUrl + '/eula-updates/confirm', { licenseTypeIds }).pipe(catchError(() => of(null)));
  }
}
